module.exports = __webpack_public_path__ + "static/media/trainVideo8.14979693.mp4";